import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Input, Row, Spin, notification} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import MerchantService from "../../../../services/ewallet_integration/merchant.service";

const MerchantDetail = ({
                            merchant, setRefresh = () => {
    },
                        }) => {
    const [form] = Form.useForm();
    const [state, setState] = useState({
        loading: false,
        save_loading: false,
        park: null,
        refresh: 0,
    })

    const updateDetail = async () => {
        const {name} = form.getFieldsValue();

        // Skip API call if name hasn't changed
        if (name === merchant.name) return;

        setState(state => ({...state, loading: true}));

        try {
            const response = await MerchantService.updateMerchantById(merchant.merchant_id, {name});

            if (response) {
                const {merchant: updatedMerchant} = response.data;
                setRefresh(true);

                notification.success({
                    description: "Merchant details have been successfully updated.",
                });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                description: "Failed to update merchant.",
            });
        } finally {
            setState(state => ({...state, loading: false}));
        }
    };


    useEffect(() => {
        if (merchant) {
            form.setFieldsValue(merchant); // Dynamically update the form
        }
    }, [merchant]);

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined/>}>
                <div>
                    <Form form={form} layout="vertical" onFinish={updateDetail}>
                        <Row gutter={24}>
                            {/* Editable Merchant Name */}
                            <Col span={12} xs={24} sm={12}>
                                <Form.Item label="Merchant Name" name="name">
                                    <Input/>
                                </Form.Item>
                            </Col>

                            {/* Read-only Wallet Name */}
                            <Col span={12} xs={24} sm={12}>
                                <Form.Item label="Wallet Name" name={['wallet', 'name']}>
                                    <Input disabled/>
                                </Form.Item>
                            </Col>

                            {/* Read-only Melon Balance */}
                            <Col span={12} xs={24} sm={12}>
                                <Form.Item label="Melon Balance" name={['wallet', 'melon_balance']}>
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                        </Row>

                        <div style={{marginTop: 12, display: 'flex'}}>
                            <div style={{marginLeft: 'auto'}}>
                                <Form.Item>
                                    <Button
                                        loading={state?.save_loading}
                                        onClick={() => form.submit()}
                                        type="primary"
                                        style={{minWidth: 200}}
                                    >
                                        Save
                                    </Button>
                                </Form.Item>
                            </div>
                        </div>
                    </Form>
                </div>
            </Spin>
        </>
    );
}

export default MerchantDetail;